import { render, staticRenderFns } from "./AssociatedSales.vue?vue&type=template&id=63b35d14&"
import script from "./AssociatedSales.vue?vue&type=script&lang=js&"
export * from "./AssociatedSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports